import { getterTypes } from './types';
import type { ProductPickerState } from '../type';

const getters = {
  [getterTypes.GET_SELECTER_ELEMENT](state: ProductPickerState) {
    return state.selecterElement;
  },
  [getterTypes.GET_FETCHED_ALL](state: ProductPickerState) {
    return state.fetched;
  },
  [getterTypes.GET_FETCHED_ALL_QUERY](state: ProductPickerState) {
    return state.queryFetched;
  },
  [getterTypes.GET_QUERY](state: ProductPickerState) {
    return state.query;
  },
  [getterTypes.GET_IS_OPEN_POPUP](state: ProductPickerState) {
    return state.isOpenPopup;
  },
  [getterTypes.GET_IS_LOADING](state: ProductPickerState) {
    return state.isLoading;
  },
  [getterTypes.GET_IS_MESSAGE](state: ProductPickerState) {
    return state.isMessage;
  },
  [getterTypes.GET_IS_REFRESH](state: ProductPickerState) {
    return state.isRefresh;
  },
  [getterTypes.GET_PRODUCTS_LIST](state: ProductPickerState) {
    return state.list;
  },
  [getterTypes.GET_QUERY_LIST](state: ProductPickerState) {
    return state.queryList;
  },
  [getterTypes.GET_CACHED_QUERY_LIST](state: ProductPickerState) {
    return state.cachedQueryList;
  },
  [getterTypes.GET_PRODUCT_MODULE_ID](state: ProductPickerState) {
    return state.productModuleId;
  },
};
export default getters;
